<div class="page-container">
  <ta-notification-box></ta-notification-box>
  <ta-pwa></ta-pwa>
  <div class="page-content">
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-incomplete-profile-modal
  [open]="this.isIncompleteProfileOpen()"
  (closeEvent)="this.isIncompleteProfileOpen.set(false)"
></app-incomplete-profile-modal>
